import { get, post } from './api'

/** The 84 Chores API. One place that knows the shapes. */

export interface Member {
  id: string
  handle: string
  display_name: string
  points: number
  coins: number
  isChild: boolean
}

export interface Family {
  id: string
  name: string
  store_name: string
  invite_code?: string
}

export interface Assignment {
  id: string
  status: 'pending' | 'submitted' | 'approved' | 'rejected'
  due_on: string
  parent_note: string | null
  points_awarded: number | null
  user_id: string
  child_name: string
  name: string
  details: string | null
  points: number
  difficulty: string
}

export interface Template { id: string; name: string; details: string | null; points: number; difficulty: string }
export interface Item { id: string; name: string; details: string | null; points_cost: number; quantity: number | null }

export const family = {
  show: () => get<{ family: Family | null; members: Member[]; you: { id: string; isParent: boolean } }>('/api/family'),
  create: (name: string) => post<{ id: string }>('/api/family', { name }),
  join: (code: string) => post<{ id: string }>('/api/family/join', { code }),
  rotate: () => post<{ invite_code: string }>('/api/family/invite'),
}

export const chores = {
  templates: () => get<{ templates: Template[] }>('/api/chores/templates'),
  createTemplate: (t: { name: string; details?: string; points: number }) => post<{ id: string }>('/api/chores/templates', t),
  assignments: (q = '') => get<{ assignments: Assignment[]; today: string }>(`/api/chores/assignments${q}`),
  assign: (templateId: string, userId: string, dueOn?: string) =>
    post<{ id: string }>('/api/chores/assignments', { templateId, userId, dueOn }),
  submit: (id: string) => post<{ ok: true }>(`/api/chores/assignments/${id}/submit`),
  review: (id: string, approve: boolean, note?: string) =>
    post<{ ok: true }>(`/api/chores/assignments/${id}/review`, { approve, note }),
}

export const store = {
  items: () => get<{ items: Item[]; balance: { points: number; coins: number } }>('/api/store/items'),
  createItem: (i: { name: string; pointsCost: number; quantity?: number | null }) => post<{ id: string }>('/api/store/items', i),
  redeem: (itemId: string) => post<{ id: string; spent: number }>('/api/store/redeem', { itemId }),
  reviewRedemption: (id: string, approve: boolean) => post<{ ok: true }>(`/api/store/redemptions/${id}/review`, { approve }),
}

export const kids = {
  create: (handle: string, displayName: string, pin: string) =>
    post<{ id: string }>('/api/delegates', { handle, displayName, pin }),
  list: () => get<{ delegates: { id: string; handle: string; display_name: string; locked: boolean }[] }>('/api/delegates'),
  unlock: (id: string) => post<{ ok: true }>(`/api/delegates/${id}`, { unlock: true }),
  ledger: () => get<{ history: { id: string; amount: number; reason: string; note: string | null; created_at: number }[]; balance: { points: number; coins: number } }>('/api/kids/ledger'),
  giveCoins: (userId: string, amount: number) => post<{ ok: true }>('/api/kids/coins', { userId, amount }),
}

/** The delegated sign-in. Handle plus PIN — see services/api/src/delegates.ts. */
export const pinSignIn = (handle: string, pin: string) =>
  post<{ user: { handle: string; displayName: string } }>('/api/auth/pin', { handle, pin })
